export default {
	DATE: 'DATE',
	DECIMAL: 'DECIMAL',
	CURRENCY: 'CURRENCY',
	AUTOCOMPLETE: 'AUTOCOMPLETE',
	CHECKBOX: 'CHECKBOX',
	RADIO: 'RADIO',
	DOCUMENT: 'DOCUMENT',
	TEXTAREA: 'TEXTAREA',
	TEXT: 'TEXT',
	LABEL: 'LABEL',
	GRID: 'GRID',
	NUMBER: 'NUMBER',
	CHART: 'CHART'
};
